module.exports = __webpack_public_path__ + "img/what-we-do-icon-1.f5393442.svg";